import { render } from "./MrZip.vue?vue&type=template&id=4e52a566&scoped=true"
import script from "./MrZip.vue?vue&type=script&lang=js"
export * from "./MrZip.vue?vue&type=script&lang=js"

import "./MrZip.vue?vue&type=style&index=0&id=4e52a566&scoped=true&lang=css"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e52a566"]])

export default __exports__